
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/youtube",
      function () {
        return require("private-next-pages/youtube/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/youtube"])
      });
    }
  